import { Injectable } from "@angular/core";
import { AngularFireMessaging } from "@angular/fire/compat/messaging";

// Example payload interface. Adjust keys/types to match your actual data.
interface MessageData {
  [key: string]: any; // fallback
}

interface MessagePayload {
  data: MessageData;
  [key: string]: any; // fallback
}

@Injectable({
  providedIn: "root",
})
export class MessagingService {
  constructor(private angularFireMessaging: AngularFireMessaging) {
    console.log("MessagingService initialized");

    // Subscribe to FCM foreground messages
    this.angularFireMessaging.messages.subscribe((npayload) => {
      console.log(
        "[firebase-messaging-foreground] Received message:",
        npayload
      );

      // Iterate over all keys in npayload and print their values
      Object.entries(npayload).forEach(([key, value]) => {
        console.log(`Key: ${key} => Value:`, value);
      });

      const payload = npayload as MessagePayload;

      console.log("Payload Data:", payload.data);
      // Iterate over all keys in npayload and print their values
      Object.entries(payload.data).forEach(([key, value]) => {
        console.log(`Key: ${key} => Value:`, value);
      });

      // only foward if data has a type, ie is a message, otherwise it might be used for other things
      if (payload.data && payload.data.type) {
        console.log(
          "Sending payload data as its own event:",
          payload.data.type
        );

        window.dispatchEvent(
          new CustomEvent(payload.data.type, {
            detail: {
              type: payload.data.type,
              payload: payload,
            },
          })
        );
      }

      // FYI
      // "serviceWorker" in navigator can be true because the browser recognizes the API at
      // a feature-detection level. But if that API is disabled or non-functional in the
      // current environment (like an iOS PWA shell), calling navigator.serviceWorker might
      // yield nothing. This discrepancy is just one of the quirks of iOS PWA support.

      if (
        "serviceWorker" in navigator &&
        navigator.serviceWorker &&
        payload.data &&
        payload.data.sound
      ) {
        this.playSound(payload.data.sound);
      }

      if (
        "serviceWorker" in navigator &&
        navigator.serviceWorker &&
        payload.notification
      ) {
        // Play the sound if present on the payload
        if (payload.notification.sound) {
          this.playSound(payload.notification.sound);
        }

        const notificationTitle =
          (payload.notification && payload.notification.title) ||
          "Background Message Title";
        const notificationOptions = {
          body:
            (payload.notification && payload.notification.body) ||
            "Background Message body.",
          icon:
            (payload.notification && payload.notification.image) ||
            "/firebase-logo.png",
          image:
            (payload.notification && payload.notification.image) ||
            "/firebase-logo.png",
        };

        // This section is really on if we are in the browser, otherwise if ios / android the service worker isn't even available
        if ("serviceWorker" in navigator && navigator.serviceWorker) {
          navigator.serviceWorker.getRegistration().then((reg) => {
            if (!reg) {
              console.warn("No service worker registration found.");
              return;
            }
            // Now call showNotification on the SW registration
            reg.showNotification(notificationTitle, notificationOptions);
          });
        } else {
          console.warn("Service Workers not supported in this browser.");
        }
      }

      // // Optionally push this out to other parts of the app via BehaviorSubject
      // this.currentMessage.next(castPayload);
    });

    if ("serviceWorker" in navigator && navigator.serviceWorker) {
      // this is for pwa service worker support
      navigator.serviceWorker.addEventListener("message", (event) => {
        console.log("Message from service worker:", event.data);
        window.dispatchEvent(
          new CustomEvent(event.data.type, {
            detail: {
              type: event.data.type,
              payload: event.data.payload,
            },
          })
        );
      });
    }

    window.addEventListener("PLAY_SOUND", (event: Event) => {
      console.log("PLAY_SOUND event received:", event);
      this.playSound((event as CustomEvent<MessagePayload>).detail.data.sound);
    });

    window.addEventListener("FORWARD_DATA", (event: Event) => {
      const customEvent = event as CustomEvent<MessagePayload>;
      console.log(
        "Angular MessagingService received FORWARD_DATA event:",
        customEvent.detail
      );

      // only foward if there is a message type
      if (customEvent.detail.data && customEvent.detail.data.type) {
        console.log(
          "Forwarding now as the specific event type:",
          customEvent.detail.data.type
        );
        window.dispatchEvent(
          new CustomEvent(customEvent.detail.data.type, {
            detail: {
              type: customEvent.detail.data.type,
              payload: customEvent.detail,
            },
          })
        );
      }
    });
  }

  /**
   * Play a sound from the provided URL (in this case, from your S3 bucket).
   */
  private playSound(soundUrl: string) {
    console.log("Playing sound:", soundUrl);
    const audio = new Audio(
      `https://sandbox-medicnow-app.s3.us-east-1.amazonaws.com/sounds/${soundUrl}`
    );
    audio.play().catch((error) => {
      console.error("Error playing audio:", error);
    });
  }
}
